var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"studentComment"},_vm._l((_vm.filterTips),function(item){return _c('div',{key:item.id},[_c('div',{staticClass:"rightcomment"},[_c('div',{staticClass:"section"},[_c('p',[_vm._v(_vm._s(item.tip))])])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }